import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from 'src/screens/home/home.component';
import { UserFormComponent } from 'src/screens/user-form/user-form.component';
import { QuestionnaireComponent } from 'src/screens/questionnaire/questionnaire.component';
import { ResultsComponent } from 'src/screens/results/results.component';

const routes: Routes = [
	{ path: '', component: HomeComponent },
	{ path: 'user', component: UserFormComponent },
	{ path: 'questionnaire', component: QuestionnaireComponent },
	{ path: 'results', component: ResultsComponent}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
	exports: [RouterModule],
})
export class AppRoutingModule {}
